module.exports = __webpack_public_path__ + "img/unsign.047e7709.png";